import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import VirusBeaconClient from '../../../clients/VirusBeaconClient';

import useQuery from '../useQuery';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

function ResultViewClinical() {
  const [numIndividuals, setNumIndividuals] = useState(null as number | null);
  const [loading, setLoading] = useState(false);
  const query = useQuery();

  const [message, setMessage] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    (async () => {
      try {
        setLoading(true);
        setNumIndividuals(null);
        const [existsIndividuals, numIndividuals] =
          await VirusBeaconClient.getCountIndividuals(
            query,
            abortController.signal
          );
        setLoading(false);
        setNumIndividuals(numIndividuals);
      } catch (error) {
        if (!abortController.signal.aborted) {
          // error!
          console.log('ERROR: ' + error);
          setLoading(false);
          setMessage('Problem with server.');
        }
      }
    })();
    return () => {
      abortController.abort();
    };
  }, [query, setNumIndividuals]);

  return (
    <div>
      <Box height="2em" />
      {loading && <CircularProgress />}
      {!loading && (
        <Alert severity="success">
          Number of individuals: {numIndividuals}
          {message && <>{message}</>}
        </Alert>
      )}
    </div>
  );
}

export default ResultViewClinical;
